// Kasadan Gider Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.cashExpense';

export const cashExpenseGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kasadan gider nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Kasadan nakit alınarak yapılan günlük harcamaları (temizlik malzemesi, tüp, kargo ücreti vb.) kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Gider formu'),
    footer: t(`${G}.regions.footer`, 'Gideri Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Nakdin alındığı kasayı seçin'),
      text: t(`${G}.s1.text`, 'Listede her kasanın yanında bakiyesi yazar; seçince altta "Mevcut bakiye" görünür. Tek kasanız varsa otomatik seçilir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube yöneticisi yalnız kendi şubesinin kasalarını görür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tutar, gider türü ve sebep'),
      text: t(`${G}.s2.text`, 'Gider tutarı, Gider türü ve Gider sebebi zorunludur. Tutar sıfırdan büyük olmalı ve kasanın mevcut bakiyesini aşmamalıdır; aşarsa "Kasada yeterli bakiye yok" uyarısı çıkar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Gider türleri Kasa sayfasındaki ⋮ menüsünden "Gider Türleri" ile tanımlanır; liste boşsa "Tanımlı gider türü yok" yazar.'),
        t(`${G}.s2.tip2`, 'Gider sebebine kısa ve açık bir not yazın (ör. "Kargo ücreti").'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Gider tarihi'),
      text: t(`${G}.s3.text`, 'Gider tarihi varsayılan olarak bugündür; geçmiş bir tarih seçebilirsiniz, ileri tarih seçilemez.'),
      tips: [
        t(`${G}.s3.tip1`, 'Şube yöneticisinde tarih alanı görünmez; gider her zaman bugünün tarihiyle kaydedilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Gideri kaydedin'),
      text: t(`${G}.s4.text`, '"Gideri Kaydet" tüm zorunlu alanlar dolunca açılır. Kayıttan sonra tutar seçilen kasanın bakiyesinden düşülür ve Kasa Hareket Raporunda gider olarak görünür.'),
    },
  ],
});
